import { useFormikContext } from "formik";
import React, { useEffect } from "react";

interface LieferantenDatenDirtyCheckerProps {
  setIsLieferantenDatenDirty: React.Dispatch<React.SetStateAction<boolean>>;
}

const getDirtyFields = <T extends Record<string, any>>(
  values: T,
  initialValues: T
): Partial<Record<keyof T, boolean>> => {
  const dirtyFields: Partial<Record<keyof T, boolean>> = {};
  (Object.keys(values) as (keyof T)[]).forEach((key) => {
    // Einfacher Vergleich - für komplexe Objekte ggf. anpassen
    if (values[key] !== initialValues[key]) {
      dirtyFields[key] = true;
    }
  });
  return dirtyFields;
};

export default function LieferantenDatenDirtyChecker({
  setIsLieferantenDatenDirty,
}: LieferantenDatenDirtyCheckerProps) {
  const { values, initialValues } = useFormikContext();

  useEffect(() => {
    const dirtyFields = getDirtyFields(values as any, initialValues as any);

    const isDirty = Boolean(
      dirtyFields.kundennummer ||
        dirtyFields.steuernummer ||
        dirtyFields.umsatzsteuerId ||
        dirtyFields.geschaefspartnerKonto
    );
    setIsLieferantenDatenDirty(isDirty);
  }, [values, initialValues, setIsLieferantenDatenDirty]);

  return null;
}
